"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _config_basicpreparations = require("@/api/config_basicpreparations");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultBasicPreparations = {
  id: '',
  basic_name: '',
  basic_content: '',
  basic_rules: ''
};
var _default = exports.default = {
  data: function data() {
    return {
      listLoading: true,
      tableData: [],
      basicpreparations: defaultBasicPreparations,
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        basic_name: [{
          required: true,
          message: '请输入基础制剂名称',
          trigger: 'blur'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      this.basicpreparations = Object.assign({}, defaultBasicPreparations);
      this.dialogType = 'new';
      this.dialogVisible = true;
    },
    getList: function getList() {
      var _this = this;
      (0, _config_basicpreparations.getBasicPreparationsAll)().then(function (response) {
        _this.tableData = response.data;
        _this.listLoading = false;
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this2 = this;
      this.basicpreparations = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs['Form'].clearValidate();
      });
    },
    handleDelete: function handleDelete(_ref) {
      var _this3 = this;
      var $index = _ref.$index,
        row = _ref.row;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _config_basicpreparations.deleteBasicPreparations)(row.id);
            case 2:
              _this3.tableData.splice($index, 1);
              _this3.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this4.dialogType === 'edit';
                  if (isEdit) {
                    (0, _config_basicpreparations.updateBasicPreparations)(_this4.basicpreparations.id, _this4.basicpreparations).then(function (res) {
                      _this4.getList();
                      _this4.dialogVisible = false;
                      _this4.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _config_basicpreparations.createBasicPreparations)(_this4.basicpreparations).then(function (res) {
                      _this4.getList();
                      _this4.dialogVisible = false;
                      _this4.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};